import { COMMON_TRANSFORM_RESPONSE_FUNCTION, INVENTORY_ACTION } from "../../../app/constants/api";
import { apiSlice } from "../../../app/redux/apiSlice";

export const InventoryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    inventoryAction: builder.mutation({
      query: ({ action, payload = {} }) => ({
        url: INVENTORY_ACTION.BASE,
        method: "POST",
        body: { action, payload },
      }),
      ...COMMON_TRANSFORM_RESPONSE_FUNCTION,
    }),
  }),
});

export const { useInventoryActionMutation } = InventoryApiSlice;
